import { useDependencies } from '@inform-appshell/fusion-kit-react';
import { Button, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getAvailableLanguagesSync } from '../../utils/languageUtils';

export function LanguageSwitch() {
  const { t, i18n } = useTranslation();
  const appDependencies = useDependencies();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const languages = getAvailableLanguagesSync();
  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0];
  const label = t('navigation.changeLanguage');

  const handleLanguageChange = (languageCode: string) => {
    setAnchor(null);
    appDependencies?.fusionApp?.logger?.info(`Changing language to ${languageCode}`);
    void i18n.changeLanguage(languageCode);
  };

  return (
    <>
      <Button
        variant="text"
        color="inherit"
        size="small"
        aria-label={label}
        title={label}
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        <span style={{ marginRight: '0.25rem' }}>{currentLanguage.flag}</span>
        {currentLanguage.code.toUpperCase()}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            selected={language.code === i18n.language}
            onClick={() => handleLanguageChange(language.code)}
          >
            <span style={{ marginRight: '0.5rem' }}>{language.flag}</span>
            <ListItemText primary={language.name} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
